"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

var _ModalCore = _interopRequireDefault(require("./core/ModalCore"));

var _constants = require("./constants");

require("./Modal.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Modal(props) {
  var footer = props.footer,
      visible = props.visible,
      wrapClassName = props.wrapClassName,
      width = props.width,
      cancelButtonProps = props.cancelButtonProps,
      okButtonProps = props.okButtonProps,
      restProps = _objectWithoutProperties(props, ["footer", "visible", "wrapClassName", "width", "cancelButtonProps", "okButtonProps"]);

  var handleCancel = function handleCancel(e) {
    var onCancel = props.onCancel;

    if (typeof onCancel === 'function') {
      onCancel(e);
    }
  };

  var handleOk = function handleOk(e) {
    var onOk = props.onOk;

    if (typeof onOk === 'function') {
      onOk(e);
    }
  };

  var renderFooter = function renderFooter() {
    var okText = props.okText,
        okType = props.okType,
        cancelText = props.cancelText,
        confirmLoading = props.confirmLoading;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
      onClick: handleCancel
    }, cancelButtonProps), cancelText), /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
      type: okType,
      loading: confirmLoading,
      onClick: handleOk
    }, okButtonProps), okText));
  };

  return /*#__PURE__*/_react.default.createElement(_ModalCore.default, _extends({}, restProps, {
    width: width,
    prefixCls: _constants.prefixCls,
    footer: footer === undefined ? renderFooter() : footer,
    visible: visible,
    onClose: handleCancel,
    transitionName: "zoom",
    closable: false
  }));
}

Modal.propTypes = {
  /** current dialog's visible status */
  visible: _propTypes.default.node,

  /** additional className for dialog wrap */
  wrapClassName: _propTypes.default.node,

  /** The cancel button props */
  cancelButtonProps: _propTypes.default.shape({}),

  /** The ok button props */
  okButtonProps: _propTypes.default.shape({}),

  /** Text of the OK button */
  okText: _propTypes.default.oneOfType(_propTypes.default.string, _propTypes.default.node),

  /** Text of the Cancel button */
  cancelText: _propTypes.default.oneOfType(_propTypes.default.string, _propTypes.default.node),

  /** Text of the Cancel button */
  okType: _propTypes.default.string,

  /** Whether to apply loading visual effect for OK button or not */
  confirmLoading: _propTypes.default.string,

  /** Specify a function that will be called when a user clicks mask,
   *  close button on top right or Cancel button */
  onCancel: _propTypes.default.func,

  /** Specify a function that will be called when a user clicks the OK button */
  onOk: _propTypes.default.func,

  /** @ignore */
  children: _propTypes.default.node,

  /** @ignore */
  footer: _propTypes.default.node,

  /** Width of modal */
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
Modal.defaultProps = {
  visible: false,
  wrapClassName: '',
  cancelButtonProps: {},
  okButtonProps: {},
  okText: 'OK',
  cancelText: 'Cancel',
  okType: 'primary',
  confirmLoading: false,
  children: null,
  onCancel: undefined,
  onOk: undefined,
  footer: undefined,
  width: 380
};
var _default = Modal;
exports.default = _default;